import { render, staticRenderFns } from "./PerspectiveInstructionsSidebarMenu.vue?vue&type=template&id=373dfd88&scoped=true&"
import script from "./PerspectiveInstructionsSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./PerspectiveInstructionsSidebarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373dfd88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('373dfd88')) {
      api.createRecord('373dfd88', component.options)
    } else {
      api.reload('373dfd88', component.options)
    }
    module.hot.accept("./PerspectiveInstructionsSidebarMenu.vue?vue&type=template&id=373dfd88&scoped=true&", function () {
      api.rerender('373dfd88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/SidebarComponents/PerspectiveInstructionsSidebarMenu.vue"
export default component.exports